export class ApiError extends Error {
  status: number;
  payload: unknown;

  constructor(message: string, status: number, payload: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.payload = payload;
  }
}

export const ADMIN_SESSION_EXPIRED_EVENT = 'ferty9-admin-session-expired';

export function authHeaders(token?: string): HeadersInit {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function requestJson<T>(input: RequestInfo | URL, init: RequestInit = {}): Promise<T> {
  const response = await fetch(apiUrl(input), { credentials: 'include', ...init });
  const text = await response.text();
  const payload = parseResponseBody(text);

  if (!response.ok) {
    if ((response.status === 401 || response.status === 403) && !isLoginRequest(input)) {
      window.dispatchEvent(new CustomEvent(ADMIN_SESSION_EXPIRED_EVENT, { detail: { status: response.status } }));
    }
    const message =
      payload && typeof payload === 'object' && 'error' in payload
        ? String(payload.error)
        : typeof payload === 'string' && payload.trim()
          ? payload
        : `Request failed with status ${response.status}`;
    throw new ApiError(message, response.status, payload);
  }

  return payload as T;
}

export function apiUrl(input: RequestInfo | URL): RequestInfo | URL {
  if (typeof input !== 'string' || input.startsWith('http://') || input.startsWith('https://')) {
    return input;
  }

  const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL?.replace(/\/+$/, '');
  return baseUrl ? `${baseUrl}${input.startsWith('/') ? input : `/${input}`}` : input;
}

function parseResponseBody(text: string): unknown {
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export function jsonInit(method: 'POST' | 'PUT', body: unknown, token?: string): RequestInit {
  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(token),
    },
    body: JSON.stringify(body),
  };
}

export function deleteInit(token?: string): RequestInit {
  return {
    method: 'DELETE',
    headers: authHeaders(token),
  };
}

function isLoginRequest(input: RequestInfo | URL) {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.pathname : input.url;
  return url.includes('/api/auth/login');
}
